import axios from 'axios';
import { API_URL } from './ApiConfig2';

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

api.interceptors.request.use(
  config => {
    try {
      const storedUser = localStorage.getItem('user');  
      const user = storedUser ? JSON.parse(storedUser) : null;

      if (user?.token) {
        config.headers.Authorization = `Bearer ${user.token}`;
      }
    } catch (error) {
      console.error('⚠️ Erro ao ler o usuário/token do localStorage:', error);
    }

    return config;
  },
  error => Promise.reject(error)
);

export default api;
